<template>
    <div class="product-add">
        <!--form表单-->
        <!--        <el-form size="small" ref="form" :model="form" label-width="150px">-->
        <!--            &lt;!&ndash;添加门店&ndash;&gt;-->
        <!--            <div class="common-form">ChatGPT设置</div>-->
        <!--            <el-form-item label="ApiKey" :rules="[{required: true,message: 'ApiKey不能为空'}]" prop="api_key">-->
        <!--                <el-input v-model="form.api_key" placeholder="请输入ApiKey" class="max-w460"></el-input>-->
        <!--                <p style="color: red">免费使用截止时间：{{ apikey_expiretime }}-->
        <!--                <p>-->
        <!--                <p style="line-height: 10px;color: grey">您填入自有API Key，提交成功后，您的API Key即刻生效。</p>-->
        <!--            </el-form-item>-->
        <!--            &lt;!&ndash;提交&ndash;&gt;-->
        <!--        <div class="common-button-wrapper">-->
        <!--            <el-button type="primary" @click="onSubmit" :loading="loading">{{$t('提交')}}</el-button>-->
        <!--            <el-button type="primary" @click="apiKeyInfo">{{$t('剩余额度')}}</el-button>-->
        <!--            <el-button type="primary" @click="apiKeyConsumLog">消费记录</el-button>-->
        <!--            <el-button type="primary" @click="apiKeyPayLog">充值记录</el-button>-->
        <!--        </div>-->
        <!--        </el-form>-->
        <el-form size="small" ref="form">
            <div class="common-form">{{$t('剩余额度')}}</div>
            <div class="cont-1">
                <div class="left-credit">
                    <p>{{$t('剩余额度')}}:</p>
                    <span>${{ remain_quota }}</span>
                </div>
                <p class="tips-gpt">{{$t('余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用')}}。</p>
            </div>

            <div class="common-form">{{$t('使用明细')}}</div>
            <div class="top-filters">
                <div class="filter-item">
                    <p class="item-name">{{$t('消费')}}</p>
                    <el-select v-model="currType" :placeholder="$t('请选择')">
                        <el-option v-for="(item, i) in typeList" :key="i" :label="item.name"
                                   :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="filter-item">
                    <p class="item-name">{{$t('起始时间')}}</p>
                    <el-date-picker
                        v-model="startDate"
                        :picker-options="startDatePickerOptions"
                        @change="startTimeChange"
                        type="date"
                        :placeholder="$t('选择日期')">
                    </el-date-picker>
                </div>
                <div class="filter-item">
                    <p class="item-name">{{$t('结束时间')}}</p>
                    <el-date-picker
                        v-model="endDate"
                        @change="endTimeChange"
                        :picker-options="endDatePickerOptions"
                        type="date"
                        :placeholder="$t('选择日期')">
                    </el-date-picker>
                </div>
                <div class="filter-item">
                    <el-button @click="queryRecords(1)">{{$t('查询')}}</el-button>
                </div>
            </div>
            <el-table size="small" class="table" :data="tableData" border style="width: 100%" v-loading="loading">
                <el-table-column prop="time" :label="$t('时间')" min-width="90"></el-table-column>
                <!--                <el-table-column prop="shop_supplier_id" :label="$t('门店')" min-width="90"></el-table-column>-->
                <el-table-column prop="type" :label="$t('类型')" min-width="90">
                    <template #default="{row}">
                        <div class="type-block" :class="[row.type === 1 ? 'type-block-consume' : 'type-block-pay']">
                            {{ row.type === 1 ? '消费' : '充值' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="quota" :label="$t('额度')" min-width="90"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :page-size="PAGE_SIZE"
                :current-page="currentPage"
                @current-change="queryRecords"
                :total="total">
            </el-pagination>
        </el-form>
    </div>
</template>

<script>
import SettingApi from '@/api/setting.js';
import {formatDateToString} from "../../../../utils/base";

export default {
    data() {
        return {
            PAGE_SIZE: 10,
            TRANS_RATE: 500000,
            /*是否正在加载*/
            loading: false,
            remain_quota: 0,
            /*form表单数据*/
            form: {
                api_key: '',
            },
            currentPage: 1,
            apikey_expiretime: '',
            currType: 1,
            startDate: '',
            endDate: '',
            typeList: [
                {
                    name: this.$t('消费'),
                    value: 1
                },
                {
                    name: this.$t('充值'),
                    value: 2
                },
            ],
            total: 0,
            tableData: [],
            startDatePickerOptions: {
                disabledDate: (time) => {
                    if (time > Date.now()) {
                        return true
                    }
                    if (this.endDate) {
                        return time.getTime() > this.endDate;
                    } else {
                        return false
                    }
                }
            },
            endDatePickerOptions: {
                disabledDate: (time) => {
                    if (time > Date.now()) {
                        return true
                    }
                    if (this.startDate) {
                        return time.getTime() < this.startDate;
                    } else {
                        return false
                    }
                }
            },
        };
    },
    created() {
        // SettingApi.actionStripe({packageid:1000}, true)
        this.getParams()
    },
    methods: {
        async queryRecords(page) {
            if (this.loading) {
                return
            }
            this.loading = true
            let res
            let _startDate
            let _endDate
            let _currType = this.currType
            let params = {
                page
            }
            if (this.startDate) {
                _startDate = formatDateToString('date', this.startDate)
                params.start = _startDate
            }
            if (this.endDate) {
                _endDate = formatDateToString('date', this.endDate)
                params.end = _endDate
            }

            if (this.currType === 1) {
                // 消费记录,是后端从第三方平台拿来的数据
                res = await SettingApi.apiKeyConsumLog(params, true)
            } else if (this.currType === 2) {
                // 充值记录
                res = await SettingApi.apiKeyPayLog(params, true)
            }
            if (res && res.code === 1) {
                this.currentPage = page
                this.tableData = []
                // console.log(res)
                if (!res.data) {
                    this.loading = false
                    return
                }
                if (_currType === 2) {
                    this.total = res.data.list.total
                    res.data.list.data.forEach((item) => {
                        let time = new Date(item.pay_time * 1000)
                        time = formatDateToString('second', time)
                        this.tableData.push({
                            time,
                            type: _currType,
                            quota: `-$${(item.quota / this.TRANS_RATE).toFixed(6)}`
                        })
                    })
                } else if (_currType === 1) {
                    if (res.data.tokenInfo.length) {
                        this.total = page * this.PAGE_SIZE + 1 // total总数并代表数据的真实总数，只是用于显示分页
                    } else {
                        this.total = page * this.PAGE_SIZE //
                    }
                    res.data.tokenInfo.forEach((item) => {
                        let time = new Date(item.created_at * 1000)
                        time = formatDateToString('second', time)
                        this.tableData.push({
                            time,
                            type: _currType,
                            quota: `+$${(item.quota / this.TRANS_RATE).toFixed(6)}`
                        })
                    })
                }
            }
            this.loading = false

            function formatTime(val) {
                if (val < 0) {
                    return ''
                }
                if (val < 10) {
                    return `0${val}`
                } else {
                    return String(val)
                }
            }
        },
        /*获取配置数据*/
        startTimeChange(date) {
            console.log(date)
            if (!this.endDate) {
                this.endDate = date
            }
        },
        endTimeChange(date) {
            if (!this.startDate) {
                this.startDate = date
            }
        },

        async getParams() {
            // let self = this;
            // SettingApi.storeChatGptDetail({}, true).then(res => {
            //     let vars = res.data.app;
            //     self.form.api_key = vars.api_key;
            //     self.apikey_expiretime = vars.apikey_expiretime
            //     self.loading = false;
            // })
            //     .catch(error => {
            //     });
            let res = await SettingApi.apiKeyInfo([], true)
            if (res && res.code === 1) {
                console.log(res)
                if (res.data && res.data.tokenInfo) {
                    this.remain_quota = (res.data.tokenInfo.remain_quota / this.TRANS_RATE).toFixed(6)
                }
            }
        },

        apiKeyInfo() {
            SettingApi.apiKeyInfo([], true)
                .then(data => {
                    console.log(data)
                })
                .catch(error => {
                });
        },

        apiKeyConsumLog() {
            SettingApi.apiKeyConsumLog({page: 5, start: "2024-01-01", end: "2024-03-06"}, true)
                .then(data => {
                    console.log(data)
                })
                .catch(error => {
                });
        },

        apiKeyPayLog() {
            SettingApi.apiKeyPayLog({page: 1}, true)
                .then(data => {
                    console.log(data)
                })
                .catch(error => {
                });
        },
        /*提交*/
        onSubmit() {
            let self = this;
            let params = this.form;
            self.$refs.form.validate((valid) => {
                if (valid) {
                    self.loading = true;
                    SettingApi.editStoreChatGpt(params, true)
                        .then(data => {
                            self.loading = false;
                            self.$message({
                                message: self.$t('恭喜你，设置成功'),
                                type: 'success'
                            });
                            self.getParams()
                            self.$router.push('/setting/store/chatgpt');
                        })
                        .catch(error => {
                            self.loading = false;
                        });
                } else {
                    self.$message({
                        message: self.$t('表单数据不符合规则'),
                        type: 'warning'
                    });
                }
            });
        },
    }
};
</script>
<style lang="scss" scoped>
.tips {
    color: #ccc;
    margin-top: -5px;
    margin-left: 150px;
    margin-bottom: 30px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type="number"] {
    -moz-appearance: textfield;
}

.product-add {
    width: 100%;
    min-width: 700px;

    /deep/ .el-table {
        margin-top: 10px;
    }

    .table {
        .type-block {
            width: 55px;
            text-align: center;
            font-size: 14px;
            border: 1px solid;
            box-sizing: border-box;
            padding: 4px;
            border-radius: 3px;
        }

        .type-block-consume {
            border-color: #df8847;
            color: #df8847;
        }

        .type-block-pay {
            border-color: #bfdf3c;
            color: #bfdf3c;
        }
    }

    /deep/ .el-pagination {
        padding: 5px 0;
        margin-top: 10px;
        display: block;
        text-align: right;
    }

    .top-filters {
        display: flex;
        justify-content: left;
        align-items: flex-end;

        /deep/ .el-button {
            height: 36px;
            box-sizing: border-box;
            padding: 6px 35px;
        }

        .filter-item {
            .item-name {
                font-size: 14px;
                color: #495060;
                font-weight: bold;
            }

            /deep/ .el-select {
                margin-top: 5px;
            }

            /deep/ .el-date-editor {
                margin-top: 5px;
                width: 150px;

            }

            /deep/ .el-input {
                .el-input__inner {
                    line-height: 36px !important;
                    height: 36px !important;
                }

                .el-input__suffix {
                    .el-input__icon {
                        line-height: 36px;
                    }
                }

                .el-input__prefix {
                    .el-input__icon {
                        line-height: 36px;
                    }
                }
            }
        }

        .filter-item:not(:first-child) {
            margin-left: 10px;
        }
    }

    .cont-1 {
        box-sizing: border-box;
        padding-left: 45px;
        padding-top: 15px;

        .left-credit {
            display: flex;
            justify-content: left;
            align-items: center;

            p {
                font-size: 16px;
            }

            span {
                margin-left: 10px;
                font-size: 24px;
                font-weight: bold;
            }
        }

        .tips-gpt {
            margin-top: 10px;
            font-size: 16px;
            color: #9f9f9f;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/views/setting/settings/store/chatgpt.vue